import { atom } from 'jotai'
import type { IndexedCue } from '../model/types'

// Base atoms for drag and drop state
export const draggedCueAtom = atom<string | null>(null)
export const draggedOverParentIdAtom = atom<string | null>(null)
export const draggedOverCueAtom = atom<string | null>(null)

// Derived atom to check if currently dragging
export const isDraggingAtom = atom<boolean>(
  (get) => get(draggedCueAtom) !== null,
)

// Write-only atom to clear drag over state
export const clearDragOverAtom = atom(null, (_, set) => {
  set(draggedOverCueAtom, null)
  set(draggedOverParentIdAtom, null)
})

// Write-only atom to clear only drag over state (for drag leave)
export const dragLeaveAtom = atom(null, (_, set) => {
  set(draggedOverCueAtom, null)
  set(draggedOverParentIdAtom, null)
})

// NEW VERSION

export const draggingCueAtom = atom<IndexedCue | null>(null)

export type OnDragStartParams = {
  cue: IndexedCue
}
export const onDragStartAtom = atom(
  null,
  (_, set, { cue }: OnDragStartParams) => {
    set(draggingCueAtom, cue)
  },
)

export const onDragEndAtom = atom(null, (_, set) => {
  set(draggingCueAtom, null)
})
